import styled from 'styled-components';

export const HrVertical = styled.div`
    border-left: 1px solid #959595;
    height: 300px;
    margin-top: 18px;
    
    @media screen and (max-width: 900px){
        display: none;
    }
`;